<template>
	<div class="modalIA" v-if="isModalVisible" @close="closeModal">
		<section class="modalIA__container">
			<div class="modalIA__head">
				<img class="modalIA__logo" src="/img/modalIA.png" alt="" />
				<h2 class="modalIA__title">Générer des QCM avec I.A</h2>
			</div>
			<form class="modalIA__insights" @submit.prevent="generateQuestion()">
				<select class="modalIA__select modalIA__select--subject" name="subject" id="subject" v-model="subject">
					<option selected :value="null">Matière *</option
					>
					<option
						v-for="subject in getUserSubjects()"
						:key="subject.id"
						:value="subject.id"
						>{{ subject.name }}</option
					>
				</select>
				<div class="input-container">
					<textarea rows="6" v-model="info" name="" id="" placeholder="Information complémentaire"></textarea>
				</div>
					<div class="modalIA__moreOptions">
						<div class="modalIA__attach">
							<label for=""><img src="/img/class/file-icon.svg">Joindre un PDF</label>
							<input
								type="file"
								@change="setFile"
								ref="fileInput"
								name="file"
								id="file"
								accept=".pdf,.txt,.jpg,.jpeg,.png"
							/>
						</div>
						<select class="modalIA__select" name="level" id="level" v-model="level">
							<option :value="null">Tous les niveaux</option
							>
							<option
								v-for="level in getUserLevels()"
								:key="level.id"
								:value="level.id"
								>{{ level.name }}</option
							>
						</select>
						<select
							v-if="showChapter"
							class="modalIA__select"
							@change="updateFilter"
							v-model="chapter"
							name="chapter"
							id="chapter"
						>
							<option :value="null">Tous les chapitres</option>

							<optgroup
								v-for="sequence in getSequence()"
								:key="sequence.id"
								:label="sequence.name"
							>
								<option
									v-for="chapter in this.$store.getters.chapters(
										sequence.id
									)"
									:key="chapter.id"
									:value="chapter.id"
								>
									{{ chapter.name }}
								</option>
							</optgroup>
						</select>
						<button class="button button--primary">Générer</button>
					</div>
					<div v-if="file" class="file-custom-preview">
						<span>{{ file.name }}</span>
						<button type="button" @click="removeFile">✖</button>
					</div>
				</form>
				<p class="page__description">
					La génération de QCM par IA est succeptible d'échouer.
					Dans un tel cas, nous vous invitons à réessayer.
				</p>
				<div class="qcm-container">
					<Loader v-if="isLoading" />
					<AIGeneratedQCMQuestion
						v-for="(question, index) in questions"
						:key="index"
						:question="question"
						:chapter="chapter || null"
						:level="level || null"
						:subject="subject || null"
						@questionAdded="questionAdded"
					/>
			</div>
		</section>
		<div class="modalIA__close" @click="closeModal"></div>
	</div>
</template>
<script>
import { checkRightFor } from "../../../utils/utils";
import Loader from "../../Loader.vue";
import AIGeneratedQCMQuestion from "../Search/QCM/AIGeneratedQCMQuestion.vue";
import { generateAiQcm } from "../../../services/aiQcmService.js";

export default {
	components: {
		AIGeneratedQCMQuestion,
		Loader
	},
	props: {
		prefilledSubject: {
			type: Number,
			default: null
		},
		prefilledLevel: {
			type: Number,
			default: null
		},
		prefilledChapter: {
			type: Number,
			default: null
		}
	},
	emits: ['close', 'questionAdded'],
	data() {
		return {
			subject: null,
			level: null,
			chapter: null,
			showChapter: true,
			questions: [],
			isQuestionAdded: false,
			isLoading: false,
			info: "",
			file: null,
			isModalVisible: true,
			startChunk: 0,
			endChunk: 0
		};
	},
	created() {
		// Pré-remplir les champs avec les props si fournis
		if (this.prefilledSubject) {
			this.subject = this.prefilledSubject;
		} else if (this.$store.state.user.subjects.length == 1) {
			this.subject = this.$store.state.user.subjects[0];
		}
		
		if (this.prefilledLevel) {
			this.level = this.prefilledLevel;
		}
		
		if (this.prefilledChapter) {
			this.chapter = this.prefilledChapter;
		}
	},
	methods: {
		closeModal() {
			this.$emit('close')
			this.isModalVisible = false;
			this.$root.$emit('refresh-questions');
		},
		setFile(event) {
			const file = event.target.files[0];
			const maxSize = 5 * 1024 * 1024; // 5 Mo
			if (file && file.size > maxSize) {
				this.$store.state.toast = {
					text: "Le fichier ne doit pas dépasser 5 Mo.",
					status: "error"
				};
				event.target.value = "";
				this.file = null;
				return;
			}
			this.file = file;
		},
		removeFile() {
			this.file = null;
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = "";
			}
		},
		checkErrors() {
			if (!this.subject) {
				this.$store.state.toast = {
					text: "Veuillez remplir le champs matière",
					status: "error"
				};
				return true;
			}
			return false;
		},
		getUserSubjects() {
			const subjects = this.$store.getters.subjects(
				this.$store.state.user.subjects
			);
			return subjects;
		},
		getUserLevels() {
			const levels = this.$store.getters.levels(
				this.$store.state.user.levels
			);
			return levels;
		},
		async questionAdded() {
			if (this.isQuestionAdded) return;
			this.$store.state.toast = {
				text: 'A retrouver dans "Mes questions"',
				status: "success"
			};
			this.isQuestionAdded = true;
			this.$emit('questionAdded');
		},
		getSequence() {
			return this.$store.getters.sequencesByLevelAndSubject(
				this.level,
				this.subject
			);
		},
		updateFilter() {
			// Méthode appelée quand le chapitre change
		},
		async generateQuestion() {
			if (!checkRightFor("QCM", [])) {
				this.$store.state.isPopUpNotAllowedVisible = true;
				return;
			}
			if (this.checkErrors()) return;
			this.isLoading = true;
			await this.$nextTick();

			try {
				this.questions = [];
				const formData = new FormData();

				if(this.subject) {
					formData.append(
						"subject_name",
						this.$store.state.subjects.find(s => s.id == this.subject)
							.name
					)
				}
			
				if(this.chapter) {
					formData.append(
						"chapter_name",
						this.$store.state.chapters.find(c => c.id == this.chapter)
							.name
					);
				}
			
				if(this.level) {
					formData.append(
						"level_name",
						this.$store.state.levels.find(l => l.id == this.level).name
					);
				}
				
				formData.append("info", this.info);
				if (this.file) {
					formData.append("file", this.file);
				}

				const res = await generateAiQcm(formData);
				this.questions = res;

				this.isLoading = false;
			} catch (error) {
				console.error(error);
				this.$store.state.toast = {
					text:
						"Une erreur est survenue pendant la génération, veuillez réessayer",
					status: "error"
				};
			} finally {
				this.isLoading = false;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/admin/ai-generated-content.scss";
</style>
